<template>
  <v-container fluid fill-height pa-0>
    <core-app-bar />
    <core-drawer />
    <core-view />
  </v-container>
</template>

<script>
import CoreView from '@/components/core/View'
import CoreDrawer from '@/components/core/Drawer'
import CoreAppBar from '@/components/core/AppBar'

export default {
  components: {
    'core-view': CoreView,
    'core-app-bar': CoreAppBar,
    'core-drawer': CoreDrawer,
  },
  computed: {
    is_Logged() {
      return this.$store.getters['login/isLogged']
    },
  },
  methods: {
    disconnect() {
      this.$store.commit('login/USER_DISCONNECT')
      this.$router.push({ name: 'login' })
    },
  },
}
</script>